/*eslint-disable*/
const path = process.env.DEVELOPMENT_SUBFOLDER
  ? process.env.DEVELOPMENT_SUBFOLDER
  : '/';

export const psoriasis = [
  {
    name: 'What Is <b><br>Moderate to Severe <br>Plaque Psoriasis</b>?',
    description1: `Plaque psoriasis is the most common form of psoriasis.<sup>1</sup>`,
    description2: `It appears as raised, red patches covered with silvery white buildup
    of dead skin cells or scales, and is often painful.<sup>2</sup>`,
    number: '1',
    content: false,

    // headerTopLine: 'basic',
    // headerBottomLine: 'scrolled',

    subsections: [
      {
        name: 'Pathophysiology',
        nameInMenu: 'Pathophysiology',
        number: '1'
      },
      {
        name: 'Prevalence <br/>and Epidemiology',
        nameInMenu: 'Prevalence <br>and Epidemiology',
        number: '2',
        animTitleTime: '1'
      },
      {
        name: 'Clinical Manifestations <br>of Plaque Psoriasis',
        nameInMenu: 'Clinical Manifestations <br>of Plaque Psoriasis',
        number: '3',
        animTitleTime: '1'
      }

    ],
    url: require('../components/ContentHeader/assets/img/section-img-1.1.png')
  },

  {
    name: 'How to Get <br>Patients <b>Started <br>on Biologics</b>',
    number: '2',
    content: false,
    animTitleTime: '1',
    subsections: [
      {
        name: 'Recommendations Before <br>Starting Biologic Treatment',
        nameInMenu: 'Recommendations Before <br>Starting Biologic Treatment',
        number: '1',
        animTitleTime: '1'
      }
    ],
    url: require('../components/ContentHeader/assets/img/section-img-1.3.png')
  },
  {
    name: 'Clinical Insights From <b><br>Dr. Jennifer Soung</b>',
    number: '3',
    content: false,
    animTitleTime: '1',
    subsections: [
      {
        name: 'Clinical Insights on the Use of Biologics <br>for the Treatment of Moderate <br>to Severe Plaque Psoriasis',
        nameInMenu: 'Clinical Insights on the Use of Biologics <br>for the Treatment of Moderate <br>to Severe Plaque Psoriasis',
        number: '1',
        animTitleTime: '1.5'
      },
      {
        name: 'Dr. Soung&#39;s Tips on Initiating Biologic <br>Treatments for Plaque Psoriasis',
        nameInMenu: 'Dr. Soung&#39;s Tips on Initiating Biologic <br>Treatments for Plaque Psoriasis',
        number: '2',
        animTitleTime: '1'
      }
    ],
    url: require('../components/ContentHeader/assets/img/section-img-1.2.png')
  },
  {
    name: 'footer',
    content: false,
    number: '4'
  }
];
export const tremfya = [
  {
    name: 'TREMFYA<sup class="header-sup">®</sup> <br class="br-small-only list-display-none"><b>Mechanism <br>of Action</b>',
    number: '1',
    content: false,
    subsections: [
      {
        name:
          'TREMFYA<sup>®</sup> Selectively Targets <br>and Binds With High Specificity <br>and Affinity to IL-23<sup>7,9,10</sup>',
        nameInMenu:'TREMFYA<sup>®</sup> Selectively Targets <br>and Binds With High Specificity <br>and Affinity to IL-23<sup>7,9,10</sup>',
        number: '1',
        animTitleTime: '1.5'
      }
    ],
    url: require('../components/ContentHeader/assets/img/section-img-2.1.png')
  },
  {
    name: 'TREMFYA<sup class="header-sup">®</sup> <b><br>Pivotal Trials</b>',
    number: '2',
    content: false,
    additionalTitle: 'In moderate to severe plaque psoriasis',
    subsections: [
      {
        name: 'TREMFYA<sup>®</sup> Has Set the Bar at PASI 90 <br>as a Primary Endpoint in Phase 3 Trials<sup>9,14</sup>',
        nameInMenu: 'VOYAGE 1 and VOYAGE 2: <br>Co-Primary Endpoints',
        number: '1',
        animTitleTime: '1'
      },
      {
        name:'TREMFYA<sup>®</sup> Achieved Consistent PASI 90 Response <br>Rates That Were Superior to <nobr>Humira<sup>®</sup> (adalimumab)</nobr> <br>at Weeks 16, 24, and 48<sup>7,9,14</sup>',
        nameInMenu:'TREMFYA<sup>®</sup> Efficacy Data: VOYAGE 1 - PASI 90',
        number: '2',
        animTitleTime: '1.5'
      },
      {
        name: 'Nearly Twice as Many Patients Were Rated as <br>Cleared (IGA 0) With TREMFYA<sup>®</sup> as With Humira<sup>®</sup>',
        nameInMenu: 'TREMFYA<sup>®</sup> Efficacy Data: VOYAGE 1 - IGA 0',
        number: '3',
        animTitleTime: '1'
      },
      {
        name:
          'VOYAGE 2 Results vs Placebo <br>and <nobr>Humira<sup>®</sup> (adalimumab)</nobr> Reflected <br>Those Achieved in VOYAGE 1<sup>9,15</sup>',
        nameInMenu:'TREMFYA<sup>®</sup> Efficacy Data: VOYAGE 2',
        number: '4',
        animTitleTime: '1'
      },
      {
        name: 'Patient Photos',
        nameInMenu: 'Patient Photos',
        number: '5',
        animTitleTime: '.5'
      },
      {
        name:
          'Consistent Response Rates at Year 1 and <br>Year 3 in an Open-label Extension',
          nameInMenu:'TREMFYA<sup>®</sup> Efficacy Data: <br>Open-Label Extension',
        number: '6',
        animTitleTime: '1'
      },
      {
        name: 'Safety Profile<sup>7,9</sup>',
        nameInMenu: 'Safety Profile<sup>7,9</sup>',
        number: '7',
        animTitleTime: '.5'
      }


    ],
    url: require('../components/ContentHeader/assets/img/section-img-2.2.png')
  },
  {
    name: 'TREMFYA<sup class="header-sup">®</sup> <b><br>Dosing and Administration</b>',
    number: '3',
    content: false,
    subsections: [
      {
        name: 'Frequency of Maintenance <br>Injections for TREMFYA<sup>®</sup>',
        nameInMenu: 'Frequency of Maintenance <br>Injections for TREMFYA<sup>®</sup>',
        number: '1',
        animTitleTime: '1'
      },
      {
        name: 'Storage and Handling<sup>9</sup>',
        nameInMenu: 'Storage and Handling<sup>9</sup>',
        number: '2'
      }
    ],
    url: require('../components/ContentHeader/assets/img/section-img-2.3.png')
  },
  {
    name: '<b>Resources</b>',
    number: '4',
    content: true,
    animTitleTime: '.5'
  },
  {
    name: '<b>References</b>',
    content: true,
    number: '5',
    url: require('../components/ContentHeader/assets/img/section-img-2.5.png'),
    animTitleTime: '.5'
  },
  {
    name: 'footer',
    content: false,
    number: '6'
  }
];
